import type {
  ITextFilter,
  ListingsAPIAndFilter,
  ListingsAPIOrFilter,
} from '@noths/polaris-client-listings-api';

export const getPartnerShortcodeFromCanonicalFilters = (
  canonicalFilters?: ListingsAPIAndFilter | ListingsAPIOrFilter,
): string | null => {
  if (!canonicalFilters || !('and' in canonicalFilters)) {
    return null;
  }

  const partnerShortcodeFilter = canonicalFilters.and.find(
    (filter): filter is ITextFilter =>
      'key' in filter && 'text' in filter && filter.key === 'attributes.partner_shortcode',
  );

  return partnerShortcodeFilter?.text[0] || null;
};
